import { Navigate, useSearchParams } from 'react-router-dom'
import { LensPageLayout } from '@/components/lens/LensPageLayout'

/** Back-compat for magic links that used /lens/report/?id=&token= before the path fix. */
export function LensReportLegacyRedirect() {
  const [searchParams] = useSearchParams()
  const reportId = searchParams.get('id')
  const token = searchParams.get('token')

  if (!reportId || !token) {
    return (
      <LensPageLayout>
        <section className="rounded-2xl border border-red-200 bg-red-50 p-6 text-red-900">
          <h1 className="text-xl font-semibold">Unable to open this report</h1>
          <p className="mt-3 text-sm leading-6">
            This report link is invalid or incomplete. Please use the secure link from your email.
          </p>
        </section>
      </LensPageLayout>
    )
  }

  return <Navigate to={`/lens/reports/${reportId}?token=${encodeURIComponent(token)}`} replace />
}
